import { gql } from "@apollo/client";

const GET_PROFILE = gql`
  query GetProfile {
    me {
      givenName
      familyName
      birthDate
      placeLivingIn
      email
      sendTips
      motherTongues
      iAmStudying
      iWantToStudy
      bio
      image
      webcalUrl
    }
    placesLivingIn {
      name
    }
    profileLanguages {
      language
    }
  }
`;

export const GET_PROFILE_AVATAR = gql`
  query {
    me {
      image
    }
  }
`;

export const GET_INVITATION_CODE = gql`
  query {
    me {
      outgoingInvitationCode
      givenName
      locale
    }
  }
`;

export const GET_PAYMENT_TYPE = gql`
  query {
    me {
      paymentType
    }
  }
`;

export default GET_PROFILE;
